import React, { Component } from 'react';
import Grid from '../../components/layout/Grid';
import TextField from '../../components/form/TextField';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import Button from '../../components/form/Button';
import Select from '../../components/form/Select';
import AddressAutocomplete, { createAddressComponentFields } from '../../components/form/AddressAutocomplete';
import Checkbox from '../../components/form/Checkbox';
import { ADDRESSBOOK_CATEGORY_OPTIONS, numberToWords } from '../../utils/strings';
import { DeleteIcon, EditIcon } from '../../components/IconIndex';
import { LEAD_SOURCES } from '../../constants/Lead';
import AutoComplete from '../../components/form/AutoComplete';
import { IconButton } from '@mui/material';
import AlertModal from '../../components/modal/AlertModal';

class ContactDetail extends Component {
    state = {
        readOnly: true,
        deliveryAddressToDelete: null,
        showDeleteDeliveryAddressAlertModel: false
    };

    constructor(props) {
        super(props);
        if (props.createNew === true) {
            this.state.readOnly = false;
        }
    }

    renderLeadSource() {
        const { form } = this.props;
        const { readOnly } = this.state;
        const options = LEAD_SOURCES;
        const selectedVal = form.getField('LeadSource.SourceType');
        const selectedOpt = !!selectedVal && options.find(opt => opt.value === selectedVal);
        const selectedText = !!selectedOpt && selectedOpt.which;
        return (
            <>
                <Grid item md={6} xs={12}>
                    {readOnly ? <TextField readOnly={readOnly} label="How did they hear about us?" value={selectedOpt.label} /> :
                        <AutoComplete
                            label="How did they hear about us?"
                            placeholder="Select a source type..."
                            options={options}
                            form={form}
                            name="LeadSource.SourceType"
                            limit={15}
                            readOnly={readOnly}
                        />}
                </Grid>

                <Grid item md={6} xs={12}>
                    <TextField
                        readOnly={readOnly}
                        label={selectedText || 'Source Name'} form={form} name="LeadSource.SourceName" />
                </Grid>
            </>
        );
    }

    handleAddDeliveryAddress() {
        const { form } = this.props;
        const DeliveryAddresses = form.getState('DeliveryAddresses') || [];
        DeliveryAddresses.push({});
        form.setState({ DeliveryAddresses });
    }

    handleCloseDeleteDeliveryAddress() {
        this.setState({ deliveryAddressToDelete: null });
        this.setState({ showDeleteDeliveryAddressAlertModel: false });
    }

    handleShowDeleteDeliveryAddress(addr) {
        this.setState({ deliveryAddressToDelete: addr });
        this.setState({ showDeleteDeliveryAddressAlertModel: true });
    }

    handleDeleteDeliveryAddress() {
        const { form } = this.props;
        const { deliveryAddressToDelete: deliveryAddress } = this.state;
        const DeliveryAddresses = form.getState('DeliveryAddresses') || [];

        const deliveryAddressIdx = DeliveryAddresses.indexOf(deliveryAddress);
        if (deliveryAddressIdx !== -1) {
            DeliveryAddresses.splice(deliveryAddressIdx, 1);
            form.setState({ DeliveryAddresses });
        }

        this.setState({ deliveryAddressToDelete: null });
        this.setState({ showDeleteDeliveryAddressAlertModel: false });
    }

    renderDeliveryAddress(addr, idx) {
        const { form } = this.props;
        const { readOnly } = this.state;
        const label = `Delivery Address ${numberToWords(idx + 1)}`;
        const addressField = createAddressComponentFields(
            'DeliveryAddresses[' + idx + ']'
        );

        return (
            <Grid key={idx} variant="justify" item>
                <Inline alignment={inlineAlignment.rightAlignSiblings} nowrap center>
                    <AddressAutocomplete
                        allowCustomAddress
                        label={label}
                        form={form}
                        readOnly={readOnly}
                        componentFields={addressField}
                    />

                    {!readOnly && (
                        <IconButton
                            className="icon"
                            title={'Delete'}
                            onClick={() => this.handleShowDeleteDeliveryAddress(addr)} size="large">
                            <DeleteIcon />
                        </IconButton>
                    )}
                </Inline>
            </Grid>
        );
    }

    render() {
        const { form, createNew } = this.props;
        const { readOnly } = this.state;
        const isFuneralDirector = 'FUNERAL DIRECTOR' === form.getField('AddressBookCategory');
        const deliveryAddresses = form.getState('DeliveryAddresses') || [];
        return (
            <Grid container spacing={3}>
                <AlertModal
                    variant="warning"
                    open={this.state.showDeleteDeliveryAddressAlertModel}
                    title="Prompt"
                    secondaryAction="Yes, Delete"
                    onClickSecondaryAction={() => this.handleDeleteDeliveryAddress()}
                    primaryAction="Cancel"
                    onClickPrimaryAction={() => this.handleCloseDeleteDeliveryAddress()}
                    onClose={() => this.handleCloseDeleteDeliveryAddress()}
                >
                    <p>You're about to delete this delivery address.</p>
                    <p>Are you sure?</p>
                </AlertModal>
                <div style={{ margin: '-12px 0', width: '100%' }}>
                    <Inline alignment={inlineAlignment.rightAlignSiblings}>
                        <div />
                        {!createNew && readOnly && (
                            <Button icon={<EditIcon />} onClick={() => this.setState({ readOnly: !readOnly })}>
                                Edit
                            </Button>
                        )}
                    </Inline>
                </div>
                <Grid item sm={6}>
                    <TextField
                        label="Business Name"
                        placeholder="Business name"
                        name="Name"
                        form={form}
                        readOnly={readOnly}
                    />
                </Grid>
                <Grid item sm={6}>
                    <TextField
                        label="Contact Person"
                        placeholder="Contact Person"
                        name="Contact"
                        form={form}
                        readOnly={readOnly}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Email" placeholder="Email" name="Email" form={form} readOnly={readOnly} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Mobile" placeholder="Mobile" name="Mobile" form={form} readOnly={readOnly} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Phone" placeholder="Phone" name="Phone" form={form} readOnly={readOnly} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Fax" placeholder="Fax" name="Fax" form={form} readOnly={readOnly} />
                </Grid>
                <Grid item>
                    <AddressAutocomplete
                        allowCustomAddress
                        label="Street/Billing Address"
                        form={form}
                        readOnly={readOnly}
                        componentFields={{
                            // businessName: `Name`,
                            line1: `AddressLine1`,
                            line2: `AddressLine2`,
                            city: `Suburb`,
                            state: `State`,
                            code: `Postcode`
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <Select
                        allowNone
                        label="Category"
                        name="AddressBookCategory"
                        form={form}
                        options={ADDRESSBOOK_CATEGORY_OPTIONS}
                        readOnly={readOnly}
                    />
                </Grid>
                {isFuneralDirector && (
                    <>
                        <Grid item xs={12} md={6}>
                            <Checkbox
                                label="Notify Before Insertion"
                                helperText="Do they want us to send an email?"
                                name="NotifyBeforeInsertion"
                                form={form}
                                readOnly={readOnly}
                            />
                        </Grid>
                        <Grid item>
                            <AddressAutocomplete
                                allowCustomAddress
                                label="Pickup Address"
                                form={form}
                                readOnly={readOnly}
                                componentFields={{
                                    businessName: `PickupAddress.Name`,
                                    line1: `PickupAddress.AddressLine1`,
                                    line2: `PickupAddress.AddressLine2`,
                                    city: `PickupAddress.Suburb`,
                                    state: `PickupAddress.State`,
                                    code: `PickupAddress.Postcode`,
                                    country: `PickupAddress.Country`
                                }}
                            />
                        </Grid>

                        {deliveryAddresses.filter((a) => a !== undefined).map((addr, idx) => this.renderDeliveryAddress(addr, idx))}

                        {!readOnly && (
                            <Grid item>
                                <Button variant="primary" onClick={() => this.handleAddDeliveryAddress()}>
                                    + Add {deliveryAddresses.length > 0 ? ' another ' : ''} Delivery Address
                                </Button>
                            </Grid>
                        )}


                        <Grid item>
                            <TextField
                                label="Body Collection Note"
                                helperText="Enter instructions for how or where their deceased are released to us."
                                name="CollectionNote"
                                form={form}
                                readOnly={readOnly}
                            />
                        </Grid>
                    </>
                )}
                <Grid item>
                    <TextField
                        label="Additional Notes"
                        name="Notes"
                        form={form}
                        multiline
                        readOnly={readOnly}
                    />
                </Grid>
                {this.renderLeadSource()}
            </Grid>
        );
    }
}

export default ContactDetail;
